import { withBemMod } from '@bem-react/core';
import { cnButton } from '@yandex-int/hr-components/Button';

import './Button_view_neuro.css';

export type WithViewNeuroProps = {
    view?: 'neuro';
};

export const withViewNeuro = withBemMod<WithViewNeuroProps>(cnButton(), {
    view: 'neour',
});
